function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import '../Charts.scss';
import * as d3 from 'd3';
import React, { Component } from 'react';
import { AVIChartTile } from '../../Layout/AVIChartTile/AVIChartTile';
import { BaseMixin } from '../Mixins/BaseMixin';
import { ColorMixin } from '../Mixins/ColorMixin';
import { CoordinateGridMixin } from '../Mixins/CoordinateGridMixin';
import { MarginsMixin } from '../Mixins/MarginsMixin';
import PropTypes from 'prop-types';
import { TileMixin } from '../Mixins/TileMixin';
import dc from 'dc';
import uid from '../../utils/uid';
export var TreeMap = /*#__PURE__*/function (_Component) {
  _inheritsLoose(TreeMap, _Component);

  function TreeMap(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "_chart", null);

    _this.chartRef = React.createRef();
    _this.getChart = _this.getChart.bind(_assertThisInitialized(_this));
    _this.chart = _this.createChart.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = TreeMap.prototype;

  _proto.createChart = function createChart(parent, chartGroup) {
    var _chart = dc.coordinateGridMixin(dc.marginMixin(dc.colorMixin(dc.baseMixin({}))));

    var _g = null;
    var _tile = null;

    _chart.tile = function (tile) {
      if (tile !== undefined) {
        _tile = tile;
        return _chart;
      } else {
        return _tile;
      }
    };

    _chart._doRender = function () {
      // Extract and sort group
      var _group = _chart.group().all().slice(0);

      var format = d3.format(',d');
      var data = d3.nest().key(function (d) {
        return d.key[0];
      }).sortKeys(d3.ascending).key(function (d) {
        return d.key[1];
      }).sortKeys(d3.ascending).rollup(function (d) {
        return d3.sum(d, function (d) {
          return d.value;
        });
      }).entries(_group);

      var treemap = function treemap(data) {
        var h = d3.hierarchy({
          key: 'top',
          values: data
        }, function (d) {
          return d.values;
        }).sum(function (d) {
          return d.value;
        }).sort(function (a, b) {
          return b.value - a.value;
        });
        var treemap = d3.treemap().tile(_tile).size([_chart.width(), _chart.height()]).padding(1).round(true)(h);
        return treemap;
      };

      var root = treemap(data); // Setup SVG

      _chart.resetSvg();

      _g = _chart.svg().append('g').attr('transform', 'translate(' + _chart.margins().left + ',' + _chart.margins().top + ')');

      var leaf = _g.selectAll('g').data(root.leaves()).join('g').attr('transform', function (d) {
        return "translate(" + d.x0 + "," + d.y0 + ")";
      });

      leaf.append('rect').attr('id', function (d) {
        return (d.leafUid = uid('leaf')).id;
      }).attr('fill', function (d) {
        while (d.depth > 1) {
          d = d.parent;
        }

        return _chart.colors()(d.data.key);
      }).attr('fill-opacity', 0.6).attr('width', function (d) {
        return d.x1 - d.x0;
      }).attr('height', function (d) {
        return d.y1 - d.y0;
      });
      leaf.append('clipPath').attr('id', function (d) {
        return (d.clipUid = uid('clip')).id;
      }).append('use').attr('xlink:href', function (d) {
        return d.leafUid.href;
      });

      if (_chart.renderTitle()) {
        leaf.append('title').text(function (d) {
          return d.ancestors().reverse().map(function (d) {
            return d.data.key;
          }).join('/') + "\n" + format(d.value);
        });
      }

      if (_chart.renderLabel()) {
        leaf.append('text').attr('clip-path', function (d) {
          return d.clipUid;
        }).selectAll('tspan').data(function (d) {
          var keys = d.ancestors().reverse().map(function (a) {
            return a.data.key;
          }).slice(1);
          keys.push(format(d.value));
          return keys;
        }).join('tspan').attr('x', 3).attr('y', function (d, i, nodes) {
          return (i === nodes.length - 1) * 0.3 + 1.1 + i * 0.9 + "em";
        }).attr('fill-opacity', function (d, i, nodes) {
          return i === nodes.length - 1 ? 0.7 : null;
        }).text(function (d) {
          return d;
        });
      }
    };

    _chart._doRedraw = function () {
      _chart._doRender();
    };

    return _chart.anchor(parent, chartGroup);
  };

  _proto.componentDidMount = function componentDidMount() {
    var _this$props = this.props,
        renderLabel = _this$props.renderLabel,
        renderTitle = _this$props.renderTitle,
        valueAccessor = _this$props.valueAccessor,
        tile = _this$props.tile,
        margins = _this$props.margins;
    this._chart = this.createChart(this.chartRef.current); // Set mixin properties

    BaseMixin(this._chart, this.props);
    ColorMixin(this._chart, this.props);
    MarginsMixin(this._chart, this.props);
    CoordinateGridMixin(this._chart, this.props);
    TileMixin(this._chart, this.props); // Set custom properties

    this._chart.tile(tile).renderLabel(renderLabel).renderTitle(renderTitle).valueAccessor(valueAccessor).margins(margins); // Render chart


    this._chart.render();
  };

  _proto.getChart = function getChart() {
    return this._chart;
  };

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement(AVIChartTile, {
      title: this.props.chartTitle,
      getChart: this.getChart,
      showTools: this.props.showTools,
      toolsComponent: this.props.toolsComponent
    }, /*#__PURE__*/React.createElement("div", {
      className: "avi-chart chart tree-map",
      ref: this.chartRef
    }));
  };

  return TreeMap;
}(Component);

_defineProperty(TreeMap, "defaultProps", {
  width: 640,
  height: 480,
  renderLabel: true,
  renderTitle: true,
  valueAccessor: function valueAccessor(d) {
    return d.value;
  },
  tile: d3.treemapBinary,
  margins: {
    left: 0,
    top: 0,
    right: 0,
    bottom: 0
  }
});

TreeMap.propTypes = process.env.NODE_ENV !== "production" ? {
  /** A Crossfilter dimension made that returns an array key, e.g. crossfilter.dimension(d=>[d.key, d.key2, ..., d.keyN]).
   * The first element in the array will be the top level of the hierarchy */
  dimension: PropTypes.object.isRequired,

  /** A Crossfilter group made on the same dimension */
  group: PropTypes.object.isRequired,

  /** Either an array of colors or a function that accepts a value and returns a color */
  colors: PropTypes.oneOfType([PropTypes.array, PropTypes.func]),

  /** Title to render on the chart */
  chartTitle: PropTypes.string,

  /** Width of diagram in pixels */
  width: PropTypes.number,

  /** Height of diagram in pixels */
  height: PropTypes.number,

  /** Render data labels in the diagram */
  renderLabel: PropTypes.bool,

  /** Render SVG:title tag, i.e. "tooltip" labels when holding the mouse above a rectangle */
  renderTitle: PropTypes.bool,

  /** Function to access the value */
  valueAccessor: PropTypes.func,

  /** Tile functions, one of d3.tilemap... functions  */
  tile: PropTypes.func,

  /** Margins object {top, bottom, left, right} */
  margins: PropTypes.object
} : {};
export default TreeMap;